import { createContext } from 'react'

/** True while the Markdown block holding a diagram is still being streamed (its source is incomplete). */
export const DiagramStreamingContext = createContext(false)
